import { ThemeMode } from "@superblocksteam/shared";
import {
  BASE_THEME_EXISTING_APPS_PADDING,
  PADDING_PRESETS_BY_THEME_VERSION,
} from "legacy/themes/paddingConstants";
import { colors } from "styles/colors";
import {
  DEFAULT_TYPOGRAPHIES_LEGACY,
  DEFAULT_TYPOGRAPHIES_NEW,
} from "./typographyConstants";
import type {
  Typographies,
  UserDefinedPalette,
  UserDefinedTheme,
} from "@superblocksteam/shared";

const CURRENT_THEME_VERSION = 5;

export const LIGHT_APP_BG = colors.GREY_25;
export const DARK_APP_BG = "#131516";

const DEFAULT_DARK_PALETTE = {
  primaryColor: colors.ACCENT_BLUE_500,
  appBackgroundColor: DARK_APP_BG,
};

const DEFAULT_LIGHT_PALETTE = {
  primaryColor: colors.ACCENT_BLUE_500,
  appBackgroundColor: LIGHT_APP_BG,
};

type UserDefinedThemeWithPalette = UserDefinedTheme & {
  palette: {
    dark: UserDefinedPalette;
    light: UserDefinedPalette;
  };
};

type UserDefinedThemeWithTypography = UserDefinedThemeWithPalette & {
  typographies: Typographies;
};

const BASE_THEME_EXISTING_APPS: UserDefinedThemeWithPalette = {
  typeFace: "Roboto",
  borderRadius: { value: 4, mode: "px" },
  mode: ThemeMode.LIGHT,
  primaryColor: colors.ACCENT_BLUE_500,
  padding: BASE_THEME_EXISTING_APPS_PADDING,
  palette: {
    dark: DEFAULT_DARK_PALETTE,
    light: DEFAULT_LIGHT_PALETTE,
  },
  version: 1,
};

const BASE_THEME_V1 = BASE_THEME_EXISTING_APPS;

const BASE_THEME_V2: UserDefinedThemeWithPalette = {
  typeFace: "Roboto",
  borderRadius: { value: 4, mode: "px" },
  mode: ThemeMode.AUTO,
  primaryColor: colors.ACCENT_BLUE_500,
  padding: PADDING_PRESETS_BY_THEME_VERSION[2].medium.value,
  palette: {
    dark: DEFAULT_DARK_PALETTE,
    light: DEFAULT_LIGHT_PALETTE,
  },
  version: 2,
};

const BASE_THEME_V3: UserDefinedThemeWithPalette = {
  typeFace: "Roboto",
  borderRadius: { value: 4, mode: "px" },
  mode: ThemeMode.AUTO,
  primaryColor: colors.ACCENT_BLUE_500,
  palette: {
    dark: DEFAULT_DARK_PALETTE,
    light: DEFAULT_LIGHT_PALETTE,
  },
  padding: PADDING_PRESETS_BY_THEME_VERSION[3].medium.value,
  version: 3,
};

const BASE_THEME_V4: UserDefinedThemeWithTypography = {
  ...BASE_THEME_V3,
  typographies: DEFAULT_TYPOGRAPHIES_LEGACY,
  version: 4,
};

const BASE_THEME_V5: UserDefinedThemeWithTypography = {
  ...BASE_THEME_V4,
  typographies: DEFAULT_TYPOGRAPHIES_NEW,
  version: 5,
};

const BASE_THEMES_BY_VERSION: Record<number, UserDefinedThemeWithPalette> = {
  1: BASE_THEME_V1,
  2: BASE_THEME_V2,
  3: BASE_THEME_V3,
  4: BASE_THEME_V4,
  5: BASE_THEME_V5,
};

export const BASE_THEME_NEW_APPS =
  BASE_THEMES_BY_VERSION[CURRENT_THEME_VERSION];
